import React from "react";
import NodePublicationTeaser from "components/Publication/NodePublicationTeaser";

export default function NodePublicationList({ nodes }) {
  return (
    <div className="flex flex-col w-full">
      {nodes.map((node) => (
        <NodePublicationTeaser node={node} key={nodes.id} />
      ))}
    </div>
  );
}
